
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiread4b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiread4b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gdh9t", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $bcdb2a40a2e0831a$export$6503ec6e8aabbaf; }, function (v) { return $bcdb2a40a2e0831a$export$6503ec6e8aabbaf = v; });
var $bcdb2a40a2e0831a$export$6503ec6e8aabbaf;
var $bcdb2a40a2e0831a$export$f7ad0328861e2f03;
"use strict";
var $bcdb2a40a2e0831a$var$mapping = new Map();
function $bcdb2a40a2e0831a$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$bcdb2a40a2e0831a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $bcdb2a40a2e0831a$var$resolve(id) {
    var resolved = $bcdb2a40a2e0831a$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$bcdb2a40a2e0831a$export$6503ec6e8aabbaf = $bcdb2a40a2e0831a$var$register;
$bcdb2a40a2e0831a$export$f7ad0328861e2f03 = $bcdb2a40a2e0831a$var$resolve;

});

parcelRegister("7NIms", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $5adf853cbbb05a06$export$bdfd709ae4826697; }, function (v) { return $5adf853cbbb05a06$export$bdfd709ae4826697 = v; });
var $5adf853cbbb05a06$export$bdfd709ae4826697;
var $5adf853cbbb05a06$export$c9e73fbda7da57b6;
var $5adf853cbbb05a06$export$5a759dc7a1cfb72a;
"use strict";
var $5adf853cbbb05a06$var$bundleURL = {};
function $5adf853cbbb05a06$var$getBundleURLCached(id) {
    var value = $5adf853cbbb05a06$var$bundleURL[id];
    if (!value) {
        value = $5adf853cbbb05a06$var$getBundleURL();
        $5adf853cbbb05a06$var$bundleURL[id] = value;
    }
    return value;
}
function $5adf853cbbb05a06$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $5adf853cbbb05a06$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $5adf853cbbb05a06$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $5adf853cbbb05a06$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$5adf853cbbb05a06$export$bdfd709ae4826697 = $5adf853cbbb05a06$var$getBundleURLCached;
$5adf853cbbb05a06$export$c9e73fbda7da57b6 = $5adf853cbbb05a06$var$getBaseURL;
$5adf853cbbb05a06$export$5a759dc7a1cfb72a = $5adf853cbbb05a06$var$getOrigin;

});

var $dbe493889119a746$exports = {};


(parcelRequire("gdh9t")).register((parcelRequire("7NIms")).getBundleURL("eLyz9"), JSON.parse('["eLyz9","index.919aa8b7.js","hH0zZ","favicon.d9e83296.png","g6D1W","food.6f2bb2b7.png","y9763","homun_bkgd1.dc65ddf5.png","2kw61","glass_panel.3b633db2.png","7dWA6","card_glow.56d7d7ac.png","dPeVz","card_glow_red.54387d9a.png","5zyHV","card_background.ee819a66.png","83oTl","nails.b8a82ee1.png","4xXH4","card_background_decor.d8943715.png","fVdoO","handy.7fa8b49b.png","fr8Sf","card_background_eat.185113bf.png","OLWtu","card_background_eat_2.0c01bd5c.png","dvh9S","event_background.c96961a2.png","jD2Ko","homunculus4.24f4773c.png","frmty","homunculus2.610c62d2.png","7LH2d","card_image.a1799d09.png","7eo62","card_gold.e20cb56b.png","41l95","card_money.e4169829.png","4t1Qa","card_medicine.57060ec9.png","1fdhi","card_corpse.7a9441f6.png","66sQJ","card_merchant.218ba203.png","lbF8P","card_the_rough_kind.a675137c.png","8asv4","card_shadow_muse.80e2a354.png","bJ1ch","card_the_law.e8ec7c95.png","kfynp","card_sonechka.6776773d.png","bCTby","card_the_id.ead336b2.png","cMA9m","card_poison.aa5e7401.png","NZ3yD","card_poison_mold.0520f702.png","9mRaN","card_alchemical_supplies.ee326987.png","iPVhW","card_booze.75b3438e.png","6imG0","card_explosives.7fe360e7.png","7Zxl9","singing_mushrooms.1c1dcf72.png","a0Ez2","the_portal.0541c92a.png","fQ1LI","the_raid.c7bf5320.png","7QTJx","enlightened_mandrake.cfcb22bf.png","j3guk","watching_flower.336de1a6.png","4Kdhw","alchemical_reaction_off.f35b594c.png","leHWE","alchemical_reaction_on.a5a3ad4b.png","5geYI","1_explosion.d2d961b9.png","7NFKC","2_explosion.2a182204.png","3A94M","3_explosion.649a91b3.png","6AN6X","4_explosion.7b338b58.png","c0s9P","5_explosion.bb396357.png","8amrb","small_heart.dd07f430.png","9o0Bn","small_food.f2edc31e.png","ghbvV","watch.1a0b31cc.png","lL13o","cloud_1.32657c97.png","mcufY","cloud_2.2f85ac3c.png","etWqS","cloud_3.95e3afc3.png","fy4IH","cloud_4.ac5f61c0.png","1FwPb","1_blood.3bb09fa0.png","4K51O","2_blood.f6535194.png","hRtdi","3_blood.f69b8f28.png","fSe1m","chat_bubble.fc2f393a.png","5llQ5","music_light.60cd5477.png","dv49J","main_menu.c49aa625.ogg","dMWKS","main_menu.221e6ed8.aac","i1ZER","board_theme_intro.42f7d77e.ogg","l7EAH","board_theme_intro.eead50fa.aac","blNZP","board_theme_loop.704d9b63.ogg","cqqP4","board_theme_loop.eeb20248.aac","1x6yQ","game_over_short.7204a955.ogg","8JHUC","game_over_short.28010dc6.aac","4DHGx","card_1.44b42c34.ogg","lPK0a","card_1.a68ac5b0.aac","9PTnK","card_2.2b774fd9.ogg","kHKAM","card_2.fd3f5eae.aac","6hDJ2","card_3.9cd717b7.ogg","dRCpd","card_3.db269ca7.aac","lhGuf","card_4.f58ff31d.ogg","3zAW2","card_4.8cab7261.aac","9NII3","bite_1.bf2a7fcd.ogg","2chEH","bite_1.132e2a74.aac","h0eTw","bite_2.6b01b551.ogg","9iY9U","bite_2.f926aa89.aac","82HH4","bite_3.b91f8fe4.ogg","qLPsh","bite_3.29963428.aac","6nzZ0","slash_splat_1.35f8ab53.ogg","lPShT","slash_splat_1.7f9c16a1.aac","btPOD","slash_splat_2.6272c1ed.ogg","jReI0","slash_splat_2.875e32a1.aac","beCBR","poof.3ab94f61.ogg","iyK5g","poof.e7022e87.aac","g3Yya","light_up.32aa58ae.ogg","cSQEP","light_up.0cb1d715.aac","feT5u","put_out.c5eedcdc.ogg","8OBSG","put_out.f76fadcd.aac","7WKX4","explosion.dcb03df3.ogg","eTUED","explosion.c1b7d453.aac"]'));


//# sourceMappingURL=index.runtime.5e7c8110.js.map
